import React from 'react';
import { Spinner } from '@tcc/crate';

import { useAppSelector } from 'app/hooks';
import { getLayersError, getIsLayersRequestPending } from 'manual/selectors';
import ZoneGenerationLayersTypesSelection from './ZoneGenerationLayersTypesSelection';
import ZoneGenerationLayersTypeContent from './ZoneGenerationLayersTypeContent';
import ZoneGenerationLayersUsabilityDisclaimer from './ZoneGenerationLayersUsabilityDisclaimer';
import ZoneGenerationErrorRequestingLayers from './ZoneGenerationErrorRequestingLayers';

const baseString = 'vra-zone-generation-layers-selection';

const Content = () => {
  const isLayersRequestPending = useAppSelector(getIsLayersRequestPending);
  const error = useAppSelector(getLayersError);

  if (isLayersRequestPending) return <Spinner className='isLoading' size='24' testId='layers-request-pending'/>;

  if (error) return <ZoneGenerationErrorRequestingLayers />;

  return (
    <>
      <ZoneGenerationLayersTypesSelection />
      <ZoneGenerationLayersTypeContent />
      <ZoneGenerationLayersUsabilityDisclaimer />
    </>
  );
};

const ZoneGenerationLayersSelection = () => {

  return (
    <section className={baseString} data-test-id={baseString}>
      <Content />
    </section>
  );
};

export default ZoneGenerationLayersSelection;
